<header class="p-d-flex p-px-4">
  <div class="logo-container">
    <em (click)="setCollapseState()" class="pi pi-bars hamburger-icon" [class.active]="!collapse" tabindex="0"
      (keyup.space)="setCollapseState()"></em>
    <hr class="divider p-mx-4">
    <a class="logo-image" [href]="portalUrl"><img src="../../../assets/images/prs-logo.svg" alt="prs-logo"></a>
    <a class="logo-image logo-mobile" [href]="portalUrl"><img src="../../../assets/images/prs-logo-mobile.svg"
        alt="prs-logo"></a>
  </div>
  <div class="right p-d-flex">
    <app-bell-notification [urlShowAll]="portalUrlPow"></app-bell-notification>
    <div class="prs-menu-dropdown-trigger" #appendTo>
      <ds-button *ngIf="!isLogged" label="Zaloguj" (onClick)="login()"></ds-button>
      <button *ngIf="isLogged" class="p-button p-button-login" (click)="toggleDropdown($event, appendTo)">
        <span class="text-truncate" [ngClass]="{'span-pb': showUserName}">
          {{displayName}}
        </span>
        <span class="text-truncate" *ngIf="showUserName">
          {{userName}}
        </span>
      </button>
    </div>
  </div>
</header>

<sirsim-menu-dropdown>
  <div class="p-my-3">
    <div class="p-my-2 dropdown-item p-px-3 p-d-flex" (click)="settings()" tabindex="0">
      <div class="p-mr-2 p-d-flex">
        <em class="pi pi-cog dropdown-icon"></em>
      </div>
      <span>Ustawienia</span>
    </div>
    <div class="p-my-2 dropdown-item p-px-3 p-d-flex" (click)="logout()" tabindex="0">
      <div class="p-mr-2 p-d-flex">
        <em class="pi pi-sign-out dropdown-icon"></em>
      </div>
      <span>Wyloguj</span>
    </div>
  </div>
</sirsim-menu-dropdown>
